import { IEGHLInfo } from '@ddot/AddToCartCommon/lib/redux';
import Config from 'Config/Config';
import { sha256 } from 'js-sha256';
import Toast from 'Lib/Toast';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Selectors from 'Redux/Selectors';
import { RootState } from 'Redux/store';
import NavActions from 'Services/Navigation/Actions';

interface PaymentWebViewProps {
    getEGHLInfo: IEGHLInfo;
}

const PaymentWebView = (props: PaymentWebViewProps) => {
    const [hashValue, setHashValue] = useState('');

    const baseUrl = Config.EGHL_PAYMENT_URL;
    const { getEGHLInfo } = props;
    const {
        Amount,
        CurrencyCode,
        CustEmail,
        CustIP,
        CustName,
        CustPhone,
        HashValue,
        MerchantCallBackURL,
        MerchantReturnURL,
        OrderNumber,
        PageTimeout,
        Param6,
        PaymentDesc,
        PaymentID,
        PymtMethod,
        ServiceID,
        TransactionType,
    } = getEGHLInfo;

    async function handleSubmit() {
        // get the form and submit right away
        const form = document.getElementById('paymentForm') as HTMLFormElement;
        if (!Amount || !CurrencyCode || !CustEmail || !CustIP || !CustName || !CustPhone || !HashValue || !MerchantCallBackURL || !MerchantReturnURL || !OrderNumber || !PageTimeout || !Param6 || !PaymentID || !PymtMethod || !ServiceID || !TransactionType) {
            Toast.showError('Something went wrong, please try again later');
            NavActions.navToHome();
        } else if (form) {
            form.submit();
            form.reset();
        }
    }

    useEffect(() => {
        handleSubmit();
    }, []);

    return (
        <div>
            <form action={baseUrl} method='post' id='paymentForm'>
                <input type='hidden' name='TransactionType' value={TransactionType} />
                <input type='hidden' name='PymtMethod' value={PymtMethod} />
                <input type='hidden' name='ServiceID' value={ServiceID} />
                <input type='hidden' name='PaymentID' value={PaymentID} />
                <input type='hidden' name='OrderNumber' value={OrderNumber} />
                <input
                    type='hidden'
                    name='PaymentDesc'
                    value={PaymentDesc || '-'}
                />
                <input type='hidden' name='MerchantName' value='Tiansi Jewellery' />
                <input
                    type='hidden'
                    name='MerchantReturnURL'
                    value={MerchantReturnURL}
                />
                <input
                    type='hidden'
                    name='MerchantCallBackURL'
                    value={MerchantCallBackURL}
                />
                <input type='hidden' name='Amount' value={Amount} />
                <input type='hidden' name='CurrencyCode' value={CurrencyCode} />
                <input type='hidden' name='CustIP' value={CustIP} />
                <input type='hidden' name='CustName' value={CustName} />
                <input type='hidden' name='CustEmail' value={CustEmail} />
                <input type='hidden' name='CustPhone' value={CustPhone} />
                <input type='hidden' name='HashValue' value={HashValue} />
                <input type='hidden' name='LanguageCode' value='en' />
                <input type='hidden' name='PageTimeout' value={PageTimeout} />
                <input type='hidden' name='Param6' value={Param6} />
            </form>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    getEGHLInfo: Selectors.getCartEGHLInfo(state),
});

const mapDispatchToProps = () => ({
    // reset data action
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentWebView);
